import React, { useState, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';

export const ContextMenu = ({ target, menuOptions }) => {
  const [xPos, setXPos] = useState('0px');
  const [yPos, setYPos] = useState('0px');
  const [showMenu, setShowMenu] = useState(false);

  const handleContextMenu = useCallback(
    (e) => {
      if (e.shiftKey && e.target.name == target) {
        e.preventDefault();
        setXPos(`${e.pageX}px`);
        setYPos(`${e.pageY - 37}px`);
        setShowMenu(true);
      } else {
        setShowMenu(false);
      }
    },
    [setXPos, setYPos, showMenu]
  );

  useEffect(() => {
    document.addEventListener('click', handleContextMenu);
    return () => {
      document.removeEventListener('click', handleContextMenu);
    };
  });

  const ContextMenuComponent = () => (
    <ul
      className={'contextual-menu ' + (showMenu ? 'open' : '')}
      style={{ top: yPos, left: xPos }}
    >
      {showMenu && menuOptions}
    </ul>
  );

  const MenuPortal = () => {
    const wrapper = document.getElementById('context-menu-wrapper');
    if (wrapper) return createPortal(<ContextMenuComponent />, wrapper);
  };

  return <MenuPortal />;
};
